import { CoreWebVitalsThresholdEvent } from "types/Events";

export function mapCoreWebVitalsToProto(
  p: CoreWebVitalsThresholdEvent["payload"]
): Record<string, unknown> {
  const rating =
    p.rating === "good"
      ? "RATING_GOOD"
      : p.rating === "needs-improvement"
      ? "RATING_NEEDS_IMPROVEMENT"
      : p.rating === "poor"
      ? "RATING_POOR"
      : "RATING_UNSPECIFIED";

  const threshold =
    p.threshold === "needs-improvement"
      ? "THRESHOLD_LABEL_NEEDS_IMPROVEMENT"
      : p.threshold === "poor"
      ? "THRESHOLD_LABEL_POOR"
      : "THRESHOLD_LABEL_UNSPECIFIED";

  const metric =
    p.metric === "LCP"
      ? "METRIC_LCP"
      : p.metric === "INP"
      ? "METRIC_INP"
      : p.metric === "CLS"
      ? "METRIC_CLS"
      : "METRIC_UNSPECIFIED";

  const out: Record<string, unknown> = {
    metric,
    value: p.value,
    rating,
    threshold,
    id: p.id,
    delta: p.delta,
    navigationType: p.navigationType,
    pageUrl: p.pageUrl,
    userAgent: p.userAgent,

    thresholdBoundaries: {
      needsImprovement: p.thresholds.needsImprovement,
      poor: p.thresholds.poor,
    },

    sentAt: new Date().toISOString(),
  };

  if (p.metric === "LCP" && p.attribution) out.lcp = p.attribution;
  if (p.metric === "INP" && p.attribution) out.inp = p.attribution;
  if (p.metric === "CLS" && p.attribution) out.cls = p.attribution;

  return out;
}
